import React, { Component } from "react";

class StoryOption extends Component{
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }
    
    componentDidMount() {

    }
    componentWillUnmount() {
        
    }

    render(){
        return(
            <React.Fragment>

            </React.Fragment>
        )
    }
}
export default StoryOption;
